<template>
    <div class="preparation-product-slip-page">
        <transition name="loading-screen">
            <LoadingScreen v-if="loading" />
        </transition>
        <template v-if="errors">
            <ErrorsZone :errors="errors" />
        </template>
        <template v-if="loadedOnce && !errors">
            <div class="row mb-2 mt-4">
                <div class="col-md-6 col-12 mx-auto">
                    <h3>Bons de fabrication</h3>
                    <div class="row mb-4">
                        <div class="col-12">
                            <form id="production-slip-form">
                                <div class="card">
                                    <div class="card-body">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Imprimer ?</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="mainCategory in mainCategories">
                                                    <td>
                                                        {{ mainCategory.name }}
                                                    </td>
                                                    <td>
                                                        <input type="checkbox" name="categories[]" :value="mainCategory.id" checked>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="form-group form-check">
                                            <input type="checkbox" class="form-check-input" name="split_pages_by_categories" id="split_pages_by_categories" value="1" checked>
                                            <label class="form-check-label" for="split_pages_by_categories">Séparer les catégories sur plusieurs pages</label>
                                        </div>
                                        <div class="alert alert-danger" v-if="hasSlot('category-error')" >
                                            <i class="fa fa-exclamation-triangle"></i>
                                            <slot name="category-error"></slot>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-12">
                            <button class="btn btn-info btn-block"
                                    form="production-slip-form"
                                    formtarget="_blank"
                                    :formaction="`/espace-employes/commandes/preparation/${endPreparationDate}/bons-de-fabrication/voir`">
                                <i class="fad fa-file-pdf fa-2x"></i>
                                <br>
                                Afficher<br />les bons de fabrication
                            </button>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div v-for="printer in printers" class="col-md-6 col-12 mb-2">
                            <button class="btn btn-primary btn-block"
                                    form="production-slip-form"
                                    @click="confirmPrint($event, 'Bons de fabrication', printer.name)"
                                    :formaction="`/espace-employes/commandes/preparation/${endPreparationDate}/bons-de-fabrication/imprimer/${printer.id}`">
                                <i class="fad fa-print fa-2x"></i>
                                <br>
                                Imprimer les bons de fabrication
                                <br>
                                {{ printer.name }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import ErrorsZone from "../../ErrorsZone";
    import LoadingScreen from "../../LoadingScreen";

    import {useGetLoader} from "../../compositions/axios/loadingRequest";

    export default {
        name: 'PreparationProductionSlipPage',

        components: {
            ErrorsZone,
            LoadingScreen,
        },

        props: {
            printers: {
                type: Array,
                required: true,
            },
            mainCategories: {
                type: Array,
                required: true,
            },
            endPreparationDate: {
                type: String,
                required: true,
            },
        },

        setup() {
            const {
                loaded,
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loaded,
                loading,
                errors,
                load,
            };
        },

        data() {
            return {
                loadedOnce: false,
            }
        },

        async mounted() {
            this.loadedOnce = true;
        },

        methods: {
            confirmPrint(event, documentName, printerName) {
                let message = 'Êtes vous sûr de vouloir lancer l\'impression du document '+documentName+' sur l\'imprimante '+printerName+' ?';
                if(!confirm(message)) {
                    event.preventDefault();
                }
            },

            hasSlot(name = 'default') {
                return !!this.$slots[name] || !!this.$scopedSlots[name];
            },
        },

    }
</script>

<style lang="scss" scoped>
    .preparation-production-slip-page {

    }
</style>
